import {
	PropsWithChildren,
	Children,
	cloneElement,
	ReactElement,
	ReactNode,
	useState
} from 'react';
import { Item } from './Item';
import { Info } from './Info';
import styles from './Timeline.module.scss';
import { Context } from './context';

type TProps = {
	dir?: 'vertical' | 'horizontal';
}

const TimelineContainer = (props: PropsWithChildren<TProps>) => {
	const { dir = 'vertical', children } = props;
	const [verticalDateWidth, setVerticalDateWidth] = useState(0);
	const childrenWithIsLastProp = () => {
		const returnChildren: (ReactElement | ReactNode)[] = [];
		const childArray = Children.toArray(children);
		childArray.forEach((Child, i) => {
			if (Child && typeof (Child as ReactElement<any>).type === 'function') {
				const isLast = i === childArray.length - 1;
				returnChildren.push(cloneElement((Child as ReactElement<any>), { isLast }));
			} else {
				returnChildren.push(Child);
			}
		});
		return returnChildren;
	}
	return <Context.Provider value={{
		dir,
		verticalDateWidth,
		setVerticalDateWidth
	}}>
		<div data-testid={'@Ofload-Timeline'} className={dir === 'vertical' ? styles.containerColumn : styles.containerRow}>{childrenWithIsLastProp()}</div>
	</Context.Provider>
}

TimelineContainer.Item = Item;
TimelineContainer.Info = Info;

export const Timeline = TimelineContainer;
